import { MESSAGE_TEMPLATES_ROUTE_PATHS } from './message-templates/config';

export const COMMUNICATIONS_ROUTE_PATHS = {
  communications: '/users/communications',
  ...MESSAGE_TEMPLATES_ROUTE_PATHS,
};

export default { RoutePaths: COMMUNICATIONS_ROUTE_PATHS };
